var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewsReward = function SvgNewsReward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2493 16C16.2493 16 14.0772 16.75 12.5 16.75C10.9228 16.75 8.74994 16 8.74994 16C8.33522 16 8 16.176 8 16.3938V21.2109C8 21.4983 8.28423 21.7547 8.76119 21.8964C8.99442 21.9653 9.24715 22 9.49988 22C9.76535 22 10.0316 21.9618 10.2716 21.8862L12.5 20.125L14.7277 21.8862C15.1964 22.0339 15.7604 22.0382 16.2388 21.8964C16.7158 21.7547 17 21.4983 17 21.2109V16.3938C17 16.176 16.664 16 16.2493 16Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.75C16.6421 15.75 20 12.3921 20 8.25C20 4.10786 16.6421 0.75 12.5 0.75C8.35786 0.75 5 4.10786 5 8.25C5 12.3921 8.35786 15.75 12.5 15.75Z",
    fill: "currentColor"
  })));
};
export default SvgNewsReward;